import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {Object} ImageSliderRef
 * @property {Array} item[]
 */

/**
 * @typedef {Object} ImageSliderInterface
 * @property {ImageSliderRef} $refs
 */

/**
 * Homepage class.
 */
export default class ImageSlider extends Base {
  /**
   * Class cofnig
   * @type {Object}
   */
  static config = {
    name: 'ImageSlider',
    refs: ['item[]'],
  };

  /**
   * show
   * @param {*} index
   */
  show(index) {
    if (this.$refs.item) {
      this.$refs.item[index].classList.remove('opacity-0');
      this.hideOtherThan(index);
    }
  }

  /**
   * hideOtherThan
   * @param {*} index
   */
  hideOtherThan(index) {
    this.$refs.item.forEach((element, i) => {
      if (i !== index) {
        this.$refs.item[i].classList.add('opacity-0');
      }
    });
  }
}
